import script from "./Reports.vue?vue&type=script&setup=true&lang=ts"
export * from "./Reports.vue?vue&type=script&setup=true&lang=ts"

import "./Reports.vue?vue&type=style&index=0&id=0c5f8bb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c5f8bb7"]])

export default __exports__